import { createSlice } from "@reduxjs/toolkit"

import { logout } from "../../LoginPage/redux/auth.actions"
import { PERKS_SLICE_NAME } from "./perks.constants"
import { getPerks } from "./perks.thunks"

/* ------------- Initial State ------------- */

const initialState = {
  fetching: false,
  list: [],
  error: null
}

/* ------------- Slice ------------- */

const slice = createSlice({
  name: PERKS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPerks.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(getPerks.fulfilled, (state, { payload }) => {
        state.fetching = false
        // The endpoint has returned both a bare array and a paginated envelope.
        state.list = Array.isArray(payload) ? payload : payload?.results || []
      })
      .addCase(getPerks.rejected, (state, { payload }) => {
        state.fetching = false
        state.error = payload
      })

      .addCase(logout, () => initialState)
  }
})

// The slice holds nothing but fetched server data, so it is not persisted — the list is
// re-requested on mount and `perks` is blacklisted from the root persist config in store.js.
export const reducer = slice.reducer
